export const BRAND_ASSETS = {
  logoColor: "/assets/brand/hopecounts-logo-color.svg",
  logoWhite: "/assets/brand/hopecounts-logo-white.svg",
  logomarkColor: "/assets/brand/hopecounts-logomark-color.svg",
};
